var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#545454","d":"m4 1 8 8.5L4 18"}));
}

ArrowRightInline.defaultProps = {"width":"16","height":"19","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
